import React, { Component } from "react";
import SoftInquiryDataTable from "../../components/DataTable/SoftInquiryDataTable";

export default class SoftInquiries extends Component {
  render() {
    return <SoftInquiryDataTable />;
  }
}
